<div *ngIf="statusList.length" class="status-container">
  <div *ngFor="let status of statusList">
    <div style="display: flex">
      @switch (status.state) {
        @case ('pending') {
          <p-progressSpinner strokeWidth="4"></p-progressSpinner>
        }
        @case ('error') {
          <i class="size22 error">highlight_off</i>
        }
        @case ('success') {
          <i class="size22 success">check</i>
        }
      }
      <span style="margin-left: 5px">
        {{ status.messageTranslateKey | translate }}
      </span>
    </div>
    @if (status.progress !== undefined) {
      <p-progressBar [value]="status.progress"></p-progressBar>
    }
  </div>
</div>
